import { render, staticRenderFns } from "./policyCreated.vue?vue&type=template&id=8c8cbaf4&scoped=true&"
import script from "./policyCreated.vue?vue&type=script&lang=js&"
export * from "./policyCreated.vue?vue&type=script&lang=js&"
import style0 from "./policyCreated.vue?vue&type=style&index=0&id=8c8cbaf4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c8cbaf4",
  null
  
)

export default component.exports